import React, { useState } from "react";
import LoadingSpinner from "views/Components/loadingSpinner";
import Pager from "../pager/Pager";
import ResourceState from "../resourceState/ResourceState";
import Transactions from "../transactions/Transactions";
import {
  displayMoney,
  getClaimStatusLabel,
  getClaimTypeLabel,
} from "../CallLeadDetails.utils";
import { sanitizePolicyHtml } from "./Claims.utils";

let policyDisclosureSequence = 0;

const Claims = ({
  claims,
  transactions,
  policies,
  packages,
  formatDate,
  onClaimsPage,
  onTransactionsPage,
}) => {
  const [policyOpen, setPolicyOpen] = useState(false);
  const [policyContentId] = useState(
    () => "cw-policy-content-" + ++policyDisclosureSequence,
  );
  const names = (packages || []).reduce((result, item) => {
    result[item.package_id] = item.catalogue_package
      ? item.catalogue_package.title
      : "Package " + item.package_id;
    return result;
  }, {});
  const policyCount = policies.data.reduce(
    (total, group) => total + (Array.isArray(group.data) ? group.data.length : 0),
    0,
  );

  return (
    <div className="cw-claims-stack">
      <section className="cw-subsection">
        <h3>Claims</h3>
        <ResourceState resource={claims} emptyText="No claims found.">
          <div className="cw-table-wrap" tabIndex="0" aria-label="Claims">
            <table className="cw-table cw-history-table">
              <thead>
                <tr>
                  <th>Claim</th>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Claimed value</th>
                </tr>
              </thead>
              <tbody>
                {claims.data.data.map((claim) => (
                  <tr key={claim.id}>
                    <td>#{claim.id}</td>
                    <td>{formatDate(claim.created_at, true)}</td>
                    <td>{getClaimTypeLabel(claim.claim_type)}</td>
                    <td>{getClaimStatusLabel(claim.status)}</td>
                    <td>{displayMoney(claim.claimed_value || claim.value)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <Pager
            page={claims.data}
            loading={claims.loading}
            onPage={onClaimsPage}
          />
        </ResourceState>
      </section>

      <section className="cw-subsection">
        <h3>Claim transactions</h3>
        <Transactions
          resource={transactions}
          formatDate={formatDate}
          onPage={onTransactionsPage}
        />
      </section>

      <section className="cw-subsection cw-policy-section">
        <h3 className="cw-policy-heading">
          <button
            type="button"
            className="cw-policy-toggle"
            aria-expanded={policyOpen}
            aria-controls={policyContentId}
            onClick={() => setPolicyOpen((open) => !open)}
          >
            <span>Policy</span>
            {!policies.loading && !policies.error ? (
              <span className="cw-policy-count">
                {policyCount} {policyCount === 1 ? "policy" : "policies"}
              </span>
            ) : null}
            <i
              className={"fa fa-chevron-" + (policyOpen ? "up" : "down")}
              aria-hidden="true"
            />
          </button>
        </h3>
        {policies.loading ? (
          <div className="cw-inline-loading">
            <LoadingSpinner />
          </div>
        ) : policies.error ? (
          <div className="cw-tab-error" role="alert">
            {policies.error}
          </div>
        ) : policyOpen ? (
          <div id={policyContentId} className="cw-policy-content">
            {policies.data.length ? (
              <div className="cw-policy-list">
                {policies.data.map((group) => (
                  <div className="cw-policy-group" key={group.packageId}>
                    <h4>
                      {names[group.packageId] || "Package " + group.packageId}
                    </h4>
                    {group.data.length ? (
                      group.data.map((policy) => (
                        <div className="cw-policy-item" key={policy.id}>
                          <strong>
                            {String(policy.type_title || "Policy").replace(
                              /_/g,
                              " ",
                            )}
                          </strong>
                          {policy.policy ? (
                            <div
                              className="cw-policy-item-content"
                              dangerouslySetInnerHTML={{
                                __html: sanitizePolicyHtml(policy.policy),
                              }}
                            />
                          ) : (
                            <p>Policy details unavailable.</p>
                          )}
                        </div>
                      ))
                    ) : (
                      <p className="cw-muted">
                        No policy information for this package.
                      </p>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <p className="cw-muted">No policy information available.</p>
            )}
          </div>
        ) : (
          <div id={policyContentId} hidden />
        )}
      </section>
    </div>
  );
};

export default Claims;
